"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerManager = void 0;
var WorkerManager = /** @class */ (function () {
    function WorkerManager(workerURL, standardIO) {
        var _this = this;
        this.handleMessageFromWorker = function (event) {
            var type = event.data.type;
            if (type === 'ready') {
                _this.resolveWorkerReady(true);
            }
            else if (type === 'stdout') {
                _this.standardIO.stdout(event.data.stdout);
            }
            else if (type === 'stderr') {
                _this.standardIO.stderr(event.data.stderr);
            }
            else if (type === 'stdin') {
                // Leave it to the terminal to decide whether to chunk it into lines
                // or send characters depending on the use case.
                _this.standardIO.stdin().then(function (inputValue) {
                    console.log('GOt some stdin: ', inputValue);
                    _this.handleStdinData(inputValue);
                });
            }
        };
        this.workerURL = workerURL;
        this.worker = null;
        this.standardIO = standardIO;
        this.initialiseWorker();
    }
    WorkerManager.prototype.initialiseWorker = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.ready = new Promise(function (resolve) {
                    _this.resolveWorkerReady = resolve;
                });
                if (!this.worker) {
                    this.worker = new Worker(this.workerURL);
                    this.worker.addEventListener('message', this.handleMessageFromWorker);
                }
                return [2 /*return*/];
            });
        });
    };
    WorkerManager.prototype.runCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ready];
                    case 1:
                        _a.sent();
                        this.stdinbuffer = new SharedArrayBuffer(100 * Int32Array.BYTES_PER_ELEMENT);
                        this.stdinbufferInt = new Int32Array(this.stdinbuffer);
                        this.stdinbufferInt[0] = -1;
                        this.worker.postMessage({
                            type: 'run',
                            buffer: this.stdinbuffer,
                            code: code
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WorkerManager.prototype.handleStdinData = function (inputValue) {
        var _this = this;
        if (this.stdinbuffer && this.stdinbufferInt) {
            var startingIndex_1 = 1;
            if (this.stdinbufferInt[0] > 0) {
                startingIndex_1 = this.stdinbufferInt[0];
            }
            var data = new TextEncoder().encode(inputValue);
            data.forEach(function (value, index) {
                _this.stdinbufferInt[startingIndex_1 + index] = value;
            });
            this.stdinbufferInt[0] = startingIndex_1 + data.length - 1;
            Atomics.notify(this.stdinbufferInt, 0, 1);
        }
    };
    return WorkerManager;
}());
exports.WorkerManager = WorkerManager;
